module.exports = __webpack_public_path__ + "MK.png?1d506598473e383dcf023d0bec229d46";